<template>
  <div class="record" id="record">
    <div class="con">
      <div class="title">{{ $t('record.p1') }}</div>
      <div class="m-r">{{ $t('record.p2') }} <span class="gold-text">{{ $t('record.p3') }}</span></div>
      <div class="des">{{ $t('record.p4') }}</div>
      <template v-if="walletAddress">
        <div class="tabs">
          <div class="t-item" :class="{ active: type === 0 }" @click="type = 0"><i class="el-icon-document"></i> {{
            $t('record.p5') }}
          </div>
          <div class="t-item" :class="{ active: type === 1 }" @click="type = 1"><i class="fa fa-gift"></i>{{
            $t('record.p6') }}</div>
        </div>
        <div class="r-list" v-if="type === 0">
          <div class="l-title"><i class="el-icon-document"></i>{{ $t('record.p7') }}</div>
          <div class="list">
            <div class="l-line header">
              <div class="h-c c-1">{{ $t('record.p8') }}</div>
              <div class="h-c c-2">{{ $t('record.p9') }}</div>
              <div class="h-c c-3">{{ $t('record.p10') }}</div>
              <div class="h-c c-4">{{ $t('record.p11') }}</div>
            </div>
            <template v-if="storageList.length > 0">
              <div class="l-line" v-for="(item, index) in storageList" :key="index">
                <div class="h-c c-1">{{ index + 1 }}</div>
                <div class="h-c c-2">{{ item.createTime }}</div>
                <div class="h-c c-3">{{ formatAddress(item.inviter) }}</div>
                <div class="h-c c-4">{{ item.amount }}</div>
              </div>
            </template>

            <div class="no-data" v-else>
              {{ $t('record.p12') }}
            </div>
          </div>
        </div>
        <div class="g-box" v-else>
          <div class="g-b-1">
            <div class="g-b-l">
              <div class="r-box">
                <i class="fa fa-gift"></i>
              </div>
              {{ $t('record.p13') }}
            </div>
            <div class="g-b-r gold-text">{{ userData.totalReward }} USDC</div>
          </div>
          <div class="g-b-2">
            <div class="gb-2-t">{{ $t('record.p14') }}</div>
            <div class="gb-2-c">
              <div class="c-item ci-1">
                <div class="c-i-t"><i class="fa fa-users"></i>{{ $t('record.p15') }}</div>
                <div class="amount">{{ userData.teamCount }} {{ $t('record.p16') }}</div>
              </div>
              <div class="c-item ci-2">
                <div class="c-i-t"><i class="fa fa-coins"></i>{{ $t('record.p17') }}</div>
                <div class="amount gold-text">{{ userData.inviteReward }} USDC</div>
              </div>
            </div>
          </div>
          <div class="list">
            <template v-if="rewardList.length === 0">
              <div class="header">
                {{ $t('record.p18') }}
              </div>
              <div class="no-data">
                {{ $t('record.p19') }}
              </div>
            </template>
            <template v-else>
              <div class="rw-list">
                <div class="l-line header">
                  <div class="h-c c-1">{{ $t('record.p20') }}</div>
                  <div class="h-c c-2">{{ $t('record.p21') }}</div>
                  <div class="h-c c-3">{{ $t('record.p22') }}</div>
                </div>
                <div class="list-scroll">
                  <div class="list-body" v-infinite-scroll="load">
                    <div class="l-line" v-for="(item, index) in rewardList" :key="index">
                      <div class="h-c c-1">{{ item.createTime }}</div>
                      <div class="h-c c-2">{{ item.type === '7' ? ' - ' : formatAddress(item.remark) }}</div>
                      <div class="h-c c-3">{{ item.type === '7' ? ' - ' : item.amount }}</div>
                    </div>
                    <p class="bot-l-info" v-if="loading">{{ $t('record.p23') }}...</p>
                    <p class="bot-l-info" v-if="noMore">{{ $t('record.p24') }}</p>
                  </div>
                </div>
              </div>
            </template>

          </div>
          <div class="invite-box">
            <a class="invite" href="#share"><i class="fa fa-gift"></i>{{ $t('record.p25') }}</a>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="not-con">
          <div class="n-c-t">{{ $t('record.p26') }}</div>
          <div class="n-c-t2">{{ $t('record.p27') }}</div>
          <div class="n-c-btn" @click="connectWallet">{{ $t('record.p28') }}</div>
        </div>
      </template>

    </div>
  </div>
</template>

<script>
import wallet from '@/common/wallet';
import { sign } from '@/common/utils'
import { mapState } from 'vuex';
const BSC_CONFIG = wallet.BSC_CONFIG
const CURRENT_NETWORK = wallet.CURRENT_NETWORK
const apiUrl = BSC_CONFIG[CURRENT_NETWORK].apiUrl

export default {
  name: 'Record',
  data() {
    return {
      type: 0,
      storageList: [],
      userData: {
        totalReward: 0,
        nodeLevel: 0,
        nodeProfit: 0,
        inviteReward: 0,
        nodeLevelName: 0,
        teamCount: 0,
        nodeProfitUnclaimed: 0,
        nodeProfitClaimed: 0
      },
      rewardList: [],
      pageNum: 1,
      total: 30,
      loading: false,
      noMore: false
    }
  },
  computed: {
    ...mapState(['walletAddress', 'apiToken', 'mintTimes'])
  },
  watch: {
    walletAddress(newVal) {
      if (newVal) this.initToken()
    },
    apiToken() {
      this.getUserData()
    },
    mintTimes() {
      this.getMintHistory()
    }
  },
  created() {
    this.getMintHistory()
  },
  methods: {
    getMintHistory() {
      let historyJsonOldStr = localStorage.getItem('easyrec_mint_history_v102')
      let historyJsonOld = historyJsonOldStr ? JSON.parse(historyJsonOldStr) : []
      let historyJson = localStorage.getItem('rwabs_mint_history_v101')
      let historyJsonNew = historyJson ? JSON.parse(historyJson) : []
      this.storageList = historyJsonOld.concat(historyJsonNew)
    },
    connectWallet() {
      if (!wallet.hasMetaMask()) {
        this.$message({
          message: this.$i18n.locale === 'zh-CN' ? '请安装 MetaMask' : 'Please install MetaMask',
          type: 'warning'
        })
        return
      }
      wallet.connectWallet().then((address) => {
        this.$store.state.walletAddress = address
        // 检查是否在 BSC 链上
        return wallet.isCorrectChain()
      }).then(function (isCorrect) {
        if (!isCorrect) {
          return wallet.switchToBSC()
        }
      }).catch(function (error) {
        this.$message({
          message: error.message,
          type: 'error'
        })
      })
    },
    formatAddress(address, prefixLength, suffixLength) {
      prefixLength = prefixLength || 6
      suffixLength = suffixLength || 4
      if (!address) return ''
      return address.slice(0, prefixLength) + '...' + address.slice(-suffixLength)
    },
    initToken() {
      let apiToken = localStorage.getItem('rwabs_api_token')
      if (!apiToken) {
        sign()
      } else {
        this.$axios.get(`${apiUrl}/address/getInfo`, {
          headers: {
            'Access-Token-Auth': apiToken
          }
        }).then(res => {
          if (res.code === 200) {
            if (res.msg.toLocaleLowerCase() !== this.walletAddress.toLocaleLowerCase()) {
              sign()
            } else {
              this.$store.state.apiToken = apiToken
            }
          }
        })
      }
    },
    getUserData() {
      this.$axios.get(`${apiUrl}/addressUsdtReward/get`, {
        headers: {
          'Access-Token-Auth': localStorage.getItem('rwabs_api_token')
        }
      }
      ).then(res => {
        console.log('res', res)
        this.userData = res.data
      })
      this.rewardList = []
      this.pageNum = 1
      this.getRewardList()
    },
    getRewardList() {
      this.loading = true
      this.$axios.get(
        `${apiUrl}/addressUsdtReward/getPage`,
        {
          headers: { 'Access-Token-Auth': localStorage.getItem('rwabs_api_token') },
          params: {
            pageNum: this.pageNum,
            pageSize: 5
          },
        }
      ).then(res => {
        this.loading = false
        this.rewardList = this.rewardList.concat(res.data.rows)
        this.total = res.data.total
      })
    },
    load() {
      if (this.loading || this.noMore) {
        return;
      }
      if (this.total > this.pageNum * 5) {
        this.pageNum++
        this.getRewardList()
      } else {
        this.noMore = true
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import './style.scss';
@import './h5-style.scss';
</style>
